import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { BaseUrl } from "../../../helper/BaseUrl";


/* ---------------- BRAND SLIDER SETTINGS ---------------- */
const getBrandSliderSettings = (length) => ({
  dots: false,
  arrows: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 5000,
  cssEase: "linear",
  slidesToShow: Math.min(3, length),
  slidesToScroll: 1,
  pauseOnHover: false,
  pauseOnFocus: false,
  swipe: false,
});

export default function ProductCards({ initialData }) {
  const [allData, setAllData] = useState(initialData || []);
  const brandSliderRefs = useRef([]);

  const settingskey = {
    autoplay: false,
    speed: 3000,
    infinite: true,
    arrows: true,
    dots: false,
    pauseOnHover: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: (
      <button className="slick-arrow slick-prev" aria-label="Previous Slide">
        <i className="fa-solid fa-arrow-left"></i>
      </button>
    ),

    nextArrow: (
      <button className="slick-arrow slick-next" aria-label="Next Slide">
        <i className="fa-solid fa-arrow-right"></i>
      </button>
    ),
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },

      {
        breakpoint: 99999,
        settings: "unslick",
      },
    ],
  };





  const fetcher = async () => {
    try {
      const response = await fetch(`${BaseUrl}/api/product-categories`, {
        method: 'GET',
      });

      const result = await response.json();
      if (result.product_categories === false) {
        throw new Error(`API error: ${result.message}`);
      }
      setAllData(result.product_categories);
    } catch (error) {
      console.error('Fetch error:', error.message);
    }
  };

  useEffect(() => {
    fetcher();
  }, [])




  return (
    <>
      <section className="products-section product-listing">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-9 mx-auto">
              <div className="choose-text center-heading">
                <h2 className="heading text-center">Products For Seamless Operations</h2>
                <p className="text-center">Engineered to optimize every workflow stage, our solutions ensure consistent performance, reliability, and efficiency across your entire laundry operation.</p>
              </div>
            </div>
          </div>

          <Slider {...settingskey} className="other-detail-slides row">
            {allData.map((products, i) => (
              <div className="col-md-6 col-lg-4" key={i}>
                <div className="product-card" >
                  <div className="img-box">
                    <img src={products?.category_thumbnail ? `${BaseUrl}${products.category_thumbnail}` : undefined}  className="img-responsive" alt={products?.alt_category_thumbnail} />
                  </div>
                  <div className="heading">{products?.name}</div>
                  <p>{products?.brief}</p>
                  <div className="brand-sliders">      
                    <Slider  {...getBrandSliderSettings(products.logos.length)} ref={(el) => (brandSliderRefs.current[i] = el)} className="brand-logo-slider" >
                      {products.logos.map((logo, index) => (
                        <div className="logos" key={index}>
                          <div className="brand-sliders-inner">
                            <img src={logo?.image ? `${BaseUrl}${logo.image}` : undefined}  className="img-responsive" alt={logo?.alt_image} />
                          </div>
                        </div>
                      ))}
                    </Slider>

                  </div>
                  <Link to={`${products?.slug}`} className="default-btn">
                    <span >{products?.button_text}</span>
                  </Link>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>
    </>
  )
}
